<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
          <template slot-scope="scope" slot="menu">
            <el-button
              type="text"
              size="small"
              v-if="permissionList.statusChangeBtn&&scope.row.status==1"
              @click="statusChange(scope.row,'2')"
            >停用
            </el-button>
            <el-button
              type="text"
              size="small"
              v-if="permissionList.statusChangeBtn&&scope.row.status!=1"
              @click="statusChange(scope.row,'1')"
            >启用
            </el-button>
          </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update, statusChange} from "@/api/v4ward/feerule/feesubject";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    labelWidth: 120,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    menuWidth: 250,
                    border: true,
                    index: false,
                    viewBtn: true,
                    selection: false,
                    dialogClickModal: false,
                    dialogWidth:600,
                    column: [ {
                      label: "id",
                      prop: "id",
                      editDisplay: false,
                      addDisplay: false,
                      viewDisplay: false,
                      hide: true,
                      rules: [{
                        required: true,
                        message: "请输入id",
                        trigger: "change"
                      }]
                    },
                                                                                                                                                                    {
                                    label: "收费科目",
                                    prop: "name",
                                    maxlength: 50,
                                    span:24,
                                    editDisabled:true,
                                    rules: [{
                                        required: true,
                                        message: "请输入收费科目",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "收费类型",
                                    prop: "feeType",
                                    span:24,
                                    editDisabled:true,
                                    type: "select",
                                    dicUrl: "/api/blade-system/dict/dictionary?code=subject_fee_type",
                                    props: {
                                        label: "dictValue",
                                        value: "dictKey",
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请选择收费类型",
                                        trigger: "change"
                                    }]
                                },
                                {
                                  label: "编码",
                                  prop: "code",
                                  span:24,
                                  maxlength: 50,
                                  editDisabled:true,
                                  rules: [{
                                    required: true,
                                    message: "请输入编码",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "税率(%)",
                                  prop: "taxRate",
                                  span:24,
                                  rules: [
                                    {
                                      pattern:/^[1-9][0-9]?$/,
                                      message: '格式错误',
                                    },
                                    {
                                      required: true,
                                      message: "请输入税率",
                                      trigger: "change"
                                    }
                                  ]
                                },
                                {
                                  label: "含税标志",
                                  prop: "taxFlag",
                                  type: "radio",
                                  span:24,
                                  dicData: [
                                    { label: '不含税', value: '0' },
                                    { label: '含税', value: '1' },
                                  ],
                                  rules: [{
                                    required: true,
                                    message: "请选择含税标志",
                                    trigger: "blur"
                                  }]
                                },
                                                                                                                {
                                    label: "日期打印设置",
                                    prop: "datePrintType",
                                    type: "radio",
                                    span:24,
                                    editDisabled:true,
                                    dicUrl: "/api/blade-system/dict/dictionary?code=fee_date_print_type",
                                       props: {
                                            label: "dictValue",
                                            value: "dictKey",
                                     },
                                    rules: [{
                                        required: true,
                                        message: "请选择日期打印设置",
                                        trigger: "blur"
                                    }]
                                },
                                {
                                  label: "状态",
                                  prop: "status",
                                  addDisplay: false,
                                  editDisabled:true,
                                  search:true,
                                  type: "select",
                                  dicData: [
                                    { label: '未启用', value: 0 },
                                    { label: '启用', value: 1 },
                                    { label: '停用', value: 2 },
                                  ]
                                },
                                {
                                  label: "备注",
                                  prop: "remark",
                                  type: "textarea",
                                  overHidden: true,
                                  span:24,
                                  maxlength: 500,
                                  showWordLimit: true,
                                  editDisabled:true,
                                  rules: [{
                                    required: false,
                                    message: "请输入备注",
                                    trigger: "change"
                                  }]
                                },

                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.feesubject_add, false),
                    viewBtn: this.vaildData(this.permission.feesubject_view, false),
                    delBtn: this.vaildData(this.permission.feesubject_delete, false),
                    editBtn: this.vaildData(this.permission.feesubject_edit, false),
                    statusChangeBtn: this.vaildData(this.permission.feesubject_statusChange, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
          statusChange(row,status) {
            this.$confirm('是否确认更改状态?', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                return statusChange({ id: row.id,status: status});
              })
              .then(() => {
                this.onLoad();
                this.$message.success('操作成功!');
              });
          },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({id: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                      if (["view"].includes(type)) {
                        setTimeout(()=>{
                          document
                            .querySelector('div[aria-label="查 看"]')
                            .querySelectorAll('div[class="el-tooltip avue-radio"]')
                            .forEach((ele)=>{
                              ele.style = "background-color:#e1e1e1;border-radius:5px;border:1px solid #ccc"
                            })
                        });
                      }
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
